import React from 'react';
import BaseStep from './BaseStep';
import ScheduleOptions from './Schedule/ScheduleOptions';
import ScheduleForm from './Schedule/ScheduleForm';

/**
 * @typedef {import('../types/ScheduleValue').ScheduleValue } ScheduleValue
 */

/**
 * Schedule step class.
 */
export default class ScheduleStep extends BaseStep {
  static id = 'schedule-step';

  static title = 'Scheduling';

  /**
   * Determines whether the wizard can proceed from the schedule step.
   * @returns {boolean} True if can proceed, false otherwise.
   */
  static canProceed() {
    return super.wizardData.isScheduleValid().isValid;
  }

  /**
   * Handles changes to the scheduling option selection.
   * @see this.wizardData.schedule
   * @see this.wizardData.selectedAssignments
   * @param {ScheduleValue|null} option - The selected scheduling option, or null if skipping scheduling.
   */
  onChange = option => {
    if (Boolean(option) !== Boolean(this.wizardData.schedule)) {
      // if changing from no schedule to a schedule or vice versa,
      // reset selected assignments to prevent invalid assignment selections
      this.wizardData.resetSelectedAssignments();
    }

    this.wizardData.schedule = option;
  };

  /**
   * Renders the step component.
   * @returns {JSX.Element} The step component.
   */
  render() {
    return (
      <>
        {this.renderNavigationPrompt(true)}
        <div className="schedule-step" data-test="schedule-step">
          <h3 data-test="schedule-step-title">Scheduling options</h3>
          <ScheduleOptions currentValue={this.wizardData.schedule} onChange={this.onChange} />
          {this.wizardData.schedule && <hr />}
          {this.wizardData.schedule && (
            <ScheduleForm currentValue={this.wizardData.schedule} onChange={this.onChange} />
          )}
        </div>
      </>
    );
  }
}
